// Core
import React from 'react';

// Components
import NavBar from 'components/NavBar.jsx';
import GeckoFeatures from 'services/gecko-features';
import CONSTANTS from 'chat-constants';

const Stats = (props) => {
  const conversationsLink = {
    to: '/stats/conversations',
    activeClassName: 'active',
    linkText: 'Conversations',
  };
  const teamsLink = {
    to: '/stats/teams',
    activeClassName: 'active',
    linkText: 'Teams',
  };
  const botsLink = {
    to: '/stats/bot',
    activeClassName: 'active',
    linkText: 'Bots',
  };
  const ratingsLink = {
    to: '/stats/ratings',
    activeClassName: 'active',
    linkText: 'Ratings',
  };
  const tagsLink = {
    to: '/stats/tags',
    activeClassName: 'active',
    linkText: 'Tags',
  };
  return (
    <div>
      <NavBar
        navLinks={
          GeckoFeatures.can('chat-bot')
            ? [conversationsLink, teamsLink, botsLink, ratingsLink, tagsLink]
            : [conversationsLink, teamsLink, ratingsLink, tagsLink]
        }
        noSearch
        items={[
          {
            type: 'default',
            name: 'Print',
            icon: 'fa fa-print',
            inactive: true,
            preset: 'save',
            handler: () => {
              window.print();
            },
          },
        ]}
      />
      <div className="content-margin">{props.children}</div>
    </div>
  );
};

export default Stats;
